import Helpers from '../modules/Helpers'
import Reveal from '../modules/Reveal'

const body = document.querySelector('body')
const modals = document.getElementsByClassName('modal')
const modalContent = document.getElementsByClassName('modal__content')
const modalOpen = document.getElementsByClassName('modal-open')
const modalClose = document.querySelectorAll('.modal, .modal-close')
const noScrollClass = 'no-scroll'

// Modal active class
const activeClass = 'modal--active'


// Listen to all modal toggle buttons in order 
// to open corresponding modal.
new Helpers(document.getElementsByTagName('body')).delegateEventListener('.modal-open', (e) => {
    let el = e.target
    if (!new Helpers(el).hasClass('modal-open')) {
        el = new Helpers(el).getClosest('.modal-open')
    }

    const modalId = el.getAttribute('aria-controls')
    const modal = document.getElementById(modalId)
    
    // condition for modals with "modal-processing" class
    // only open them if the form is valid and in a submittable state
    if (new Helpers(modal).hasClass('modal-processing')) {
        const form = new Helpers(e.target).getClosest('form')
        if (!form.checkValidity()) {
            return
        }
    }

    new Reveal(modal).show(activeClass)
    new Helpers(body).addClass(noScrollClass)

    // if this is a standard modal, prevent the original click event from proceeding
    // otherwise continue, this has been added to accomodate loading modals that have the class .modal-processing
    if (new Helpers(modal).hasClass('modal')) {
        e.preventDefault()
    }

    const modalType = el.getAttribute('data-modal-type')
    const modalValue = el.getAttribute('data-modal-value')
    if (modalType !== null) {
        window.dataLayerQueue = window.dataLayerQueue || []
        window.dataLayerQueue.push({ 'event': 'modalOpen', 'modalType': modalType, 'modalValue': modalValue })
    }

})


// Listen to all modal toggle buttons in order 
// to close corresponding modal.
new Helpers(document.getElementsByTagName('body')).delegateEventListener('.modal, .modal-close', (e) => {
    if (new Helpers(e.target).getClosest('.modal-close') || !new Helpers(e.target).getClosest('.modal__content')) {
        new Reveal(modals).hide(activeClass)
        new Helpers(body).removeClass(noScrollClass)
    }
})

